import { defaultStoreUtils } from '@databases/redux';
import { ViewId } from '@databases/types/database/view';
import { getViewById, viewHasChanges } from '@databases/utils/database/view/view';
import { selectDatabaseByContentIdRequired } from '@databases/utils/redux/databases/selectors';
import { useMemo } from 'react';

import useView from './useView';

type UseViewHasUnsavedChangesOptions = {
  contentId: string;
};

export const useViewHasUnsavedChanges = ({
  contentId,
}: UseViewHasUnsavedChangesOptions) => {
  const { view, unsavedView } = useView();

  const savedViews = defaultStoreUtils.useEqualSelector((state) => {
    const database = selectDatabaseByContentIdRequired(state, { contentId });
    return database.views;
  });

  const originalView = useMemo(
    () => getViewById(savedViews, view.id),
    [savedViews, view.id]
  );

  const hasChanges = useMemo(() => {
    if (unsavedView && view.id === ViewId.UNSAVED) {
      return true;
    }

    return (
      (originalView && viewHasChanges(view.settings, originalView.settings)) ?? false
    );
  }, [originalView, unsavedView, view.id, view.settings]);

  return hasChanges;
};
